const numericConstants = {
  TWO: 2,
  NINE: 9,
  TEN: 10,
  THIRTY_SIX: 36,
  FIFTY: 50,
  FIVE_HUNDRED: 500,
  THOUSAND: 1000,
  TEN_THOUSAND: 10000,
};

export default numericConstants;
